<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">用户置顶</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>申请人：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em" @change="updateObj">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>联系进度：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证：</label>
          <el-select v-model="overallAuthState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in overallAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="申请时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <ElButtons icon="Comment" @click="sendSysMsg">发送通知</ElButtons>
          <el-button type="primary" @click="batchUpdate()" v-loading="batchLoading">批量置顶</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            v-loading="listLoading"
        >
          <el-table-column type="selection" width="40" align="center" class-name="cursor"/>
          <el-table-column property="createTime" label="申请时间" v-if="checkColList.indexOf('申请时间') > -1"/>

          <el-table-column label="申请人" v-if="checkColList.indexOf('申请人') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city"/>
            </template>
          </el-table-column>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="106">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column property="" label="自我介绍" v-if="checkColList.indexOf('自我介绍') > -1">
            <template #default="scope">
              <p>{{ scope.row.pdesc }}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="认证情况" v-if="checkColList.indexOf('认证情况') > -1" width="160">
            <template #default="scope">
              <p>身份证：{{scope.row.identityAuth.overallAuthState == 0 ? "未提交" : scope.row.identityAuth.overallAuthState == 1 ? "待审核" : scope.row.identityAuth.overallAuthState == 2 ? "审核通过" : scope.row.identityAuth.overallAuthState == 3 ? "审核不通过" : ""}}</p>
              <p>学历：<span v-if="scope.row.authEdu">{{scope.row.authEdu.eduState==0?'已保存':scope.row.authEdu.eduState==1?'待认证':scope.row.authEdu.eduState==2?'已认证':scope.row.authEdu.eduState==3?'认证失败':'未申请认证'}}</span><span v-else>未申请认证</span></p>
              <p>职业：<span v-if="scope.row.authJob">{{scope.row.authJob.jobState==0?'默认客户端保存没去申请认证':scope.row.authJob.jobState==1?'待认证':scope.row.authJob.jobState==2?'已认证':scope.row.authJob.jobState==3?'认证失败':'未申请认证'}}</span><span v-else>未申请认证</span></p>
              <p>车辆：<span v-if="scope.row.authCar">{{scope.row.authCar.carState==0?'默认客户端保存没去申请认证':scope.row.authCar.carState==1?'待认证':scope.row.authCar.carState==2?'已认证':scope.row.authCar.carState==3?'认证失败':'未申请认证'}}</span><span v-else>未申请认证</span></p>
              <p>房产：<span v-if="scope.row.authHouse">{{scope.row.authHouse.houseState==0?'默认客户端保存没去申请认证':scope.row.authHouse.houseState==1?'待认证':scope.row.authHouse.houseState==2?'已认证':scope.row.authHouse.houseState==3?'认证失败':'未申请认证'}}</span><span v-else>未申请认证</span></p>
            </template>
          </el-table-column>
          <el-table-column label="微信" v-if="checkColList.indexOf('微信') > -1" width="116">
            <template #default="scope">
              <p v-if="!scope.row.wechat">未提交</p>
              <p v-else>{{scope.row.wechat.totalState==0?'未提交':scope.row.wechat.totalState==1?'待审核':scope.row.wechat.totalState==2?'已通过':scope.row.wechat.totalState==3?'未通过':''}}</p>
            </template>
          </el-table-column>
          <el-table-column label="微信二维码" v-if="checkColList.indexOf('微信二维码') > -1" width="116">
            <template #default="scope">
              <GetPlain v-if="scope.row.wechat" :url="scope.row.wechat.img" :uid="scope.row.uid" :type="11" :subType="0"/>
            </template>
          </el-table-column>
          <el-table-column property="" label="展示状态" v-if="checkColList.indexOf('展示状态') > -1">
            <template #default="scope">
              <p>{{scope.row.resumeState==0?'信息未提交':scope.row.resumeState==1?'信息待审核':scope.row.resumeState==2?'信息已通过':scope.row.resumeState==3?'信息不通过':''}}</p>
              <p>{{scope.row.isDel==0?'展示中':scope.row.isDel==1?'已隐藏':''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="marriageExpireDay" label="SVIP剩余时间"  v-if="checkColList.indexOf('SVIP剩余时间') > -1">
            <template #default="scope">
              <span v-if="scope.row.svipState == 2">终身SVIP</span>
              <span v-if="scope.row.marriageExpireDay">{{ scope.row.marriageExpireDay }}天</span>
            </template>
          </el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>{{scope.row.state==0?'待审核':scope.row.state==1?'展示中':scope.row.state==2?'已取消':scope.row.state==3?'已过期':''}}</p>
              <p>{{scope.row.updateTime}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space direction="vertical" alignment="left">
                <el-button type="success" size="small" v-show="scope.row.state!=1 && scope.row.state!=3" @click="updateState(scope.$index, scope.row, 1)" v-loading="scope.row.reLoading">置顶</el-button>
                <el-button type="danger" size="small" v-show="scope.row.state==1" @click="updateState(scope.$index, scope.row, 2)" v-loading="scope.row.reLoading">取消置顶</el-button>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="180">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import {
  getUserTopPageList,
  updateUserTopState
} from '../../api/url'
import {getFormData, postFormData} from '@/api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import SendSystemMessageChat from "@/components/SendSystemMessageChat";
import ExpireUserSearchInfoDialog from "@/views/marriage/components/ExpireUserSearchInfoDialog";
import GetPlain from "@/components/resume/GetPlain";
import remarkDialog from "@/views/marriage/components/remarkDialog";
import updateMatcherStateDialog from "@/views/marriage/components/updateMatcherStateDialog";

export default {
  name: "UserTop",
  components: { DatePickerRange, SearchComponents, UserLog, GetPlain },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      //状态
      stateArray: [
        { label: "不限", value: -1 },
        { label: "待审核", value: 0 },
        { label: "展示中", value: 1 },
        { label: "已取消", value: 2 },
        { label: "已过期", value: 3 },
      ],
      state: 0,

      // 身份认证
      overallAuthStateArray: [
        {label: "不限", value: -1},
        {label: "未提交", value: 0},
        {label: "待审核", value: 1},
        {label: "认证成功", value: 2},
        {label: "认证失败", value: 3},
      ],
      overallAuthState: 2,

      //时间
      startTime: '',
      endTime: '',
      isChecked: false,


      //搜索
      searchType : '',
      searchValue: '',

      //刷新组
      colList: ['申请时间', '申请人', '头像', '自我介绍', '认证情况', '微信', '微信二维码', '展示状态', 'SVIP剩余时间', '状态', '操作', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      idArray: [],
      updateLoading: false,
      batchLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getBirthTime(val) {
      this.birthdayStartTime = val[0];
      this.birthdayEndTime = val[1];
      // console.log(val)
    },
    getBirthCheck(val) {
      this.isBirthChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = false;
      this.sex = -1;
      this.state = -1;
      this.overallAuthState = 2;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['state'] = this.state;
      param['overallAuthState'] = this.overallAuthState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getUserTopPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '申请人日志') {
        Dialog.open({
          title: '申请人日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //更新用户日志
      if(column.label == '联系对象日志') {
        Dialog.open({
          title: '联系对象日志',
          component: UserLogDialog,
          data: {
            id: row.toUserId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //婚恋服务购买记录
      if(column.label == '服务备注') {
        Dialog.open({
          title: '服务备注',
          component: remarkDialog,
          data: {
            remark: row.remark,
            id: row.userId,
          },
          confirm: (result) => {
            row.remark = result.remark
          }
        })
      }

    },



    //更新
    updateState(idx, row, state) {
      this.$confirm('确定要对用户'+'【' + row.nickName + '】的信息置顶进行展示操作？').then(()=>{
        this.pageDataList[idx]['reLoading'] = true
        let idArr = []
        idArr.push(row.id)
        let param = {}
        param['idArr'] = idArr
        param['state'] = state
        postFormData(updateUserTopState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList.splice(idx, 1)
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['reLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['reLoading'] = false
        })
      })
    },

    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        component: ExpireUserSearchInfoDialog,
        data: {
          userForm: e,
          idx: -1,
          width: '600px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    //发送系统消息
    sendSysMsg() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessageChat,
        data: {
          userIdArray: this.idArray,
          width: '600px'
        },
        confirm: () => {

        }
      })
    },

    /**
     * 批量置顶
     */
    batchUpdate() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      this.$confirm('确定要批量置顶？').then(()=>{
        this.batchLoading = true
        let param = {}
        param['idArr'] = this.idArray
        param['state'] = 1
        postFormData(updateUserTopState, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.getPage()
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.batchLoading = false
        }).catch(()=>{
          this.batchLoading = false
        })
      })
    },

  },
  created() {
  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
